export const listSortStorageKey = (userId, boardId) =>
  userId && boardId ? `tasks.listSort.v1:${userId}:${boardId}` : null;

export const readListSortPreferences = (key) => {
  const preferences = { sortModes: {}, reversedLists: {} };
  if (!key) return preferences;
  try {
    const stored = JSON.parse(window.localStorage.getItem(key));
    if (!stored || typeof stored !== "object") return preferences;
    for (const [listId, mode] of Object.entries(stored.sortModes || {})) {
      if (/^[1-9]\d*$/.test(listId) && ["manual", "deadline", "title"].includes(mode)) {
        preferences.sortModes[listId] = mode;
      }
    }
    for (const [listId, reversed] of Object.entries(stored.reversedLists || {})) {
      if (/^[1-9]\d*$/.test(listId) && typeof reversed === "boolean") {
        preferences.reversedLists[listId] = reversed;
      }
    }
  } catch (error) {
    // Unavailable storage or invalid saved data must not prevent using the board.
  }
  return preferences;
};

export const saveListSortPreferences = (key, preferences) => {
  if (!key) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(preferences));
  } catch (error) {
    // Sorting still works for this visit when storage is disabled or full.
  }
};
